import React from 'react'
import styled from 'styled-components'
import { Page } from '../common'
import { Spinner } from '../common/Spinner'
import { Colors } from '../constants'

export function LoadingPage() {
  return (
    <Page>
      <Container>
        <Spinner />
      </Container>
    </Page>
  )
}

const Container = styled.div`
  margin-top: 20px;
  padding: 50px 0;
  display: flex;
  color: ${Colors.White};
  align-items: center;
  justify-content: center;
`
